/**
 * @module geo/types
 */
import { Feature } from './feature';

/**
 * Interface of transaction.
 */
export interface FeatureTransactionOperation {

  /**
   * type of operation to be executed
   * INSERT, UPDATE, DELETE
   */
  operation: OperationType,
  /**
   * Source Id (geometry modification or infosheet)
   */
  source: string,
  /**
   * list of features
   */
  features: Feature[],
  /**
   * list of related operation to execute
   */
  related?: RelatedOperation[];
}

export enum OperationType {
  INSERT = 'INSERT',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE'
}

/**
 * Related operation interface
 */
interface RelatedOperation {
  /**
   * id of related operation if related with feature added in operation
   */
  modificationId?: string;
  /**
   * feature id if feature already exists
   */
  featureId?: string;
  /**
   *
   */
  path: string;
  /**
   *
   */
  index: 0 | 1;
  /**
   * type f relation
   * 'DEPENDENCY' | 'PARENT' | 'TOPOLOGY'
   */
  relation: OperationRelation;
}

enum OperationRelation {
  DEPENDENCY = 'DEPENDENCY',
  PARENT = 'PARENT',
  TOPOLOGY = 'TOPOLOGY'
}

export interface FeatureTransactionResult {
  /**
   * List of features ids created by current operation
   */
  created: string[];
  /**
   * List of features ids deleted by current operation
   */
  deleted: string[];
  /**
   * List of features ids updated by current operation
   */
  updated: string[];
  /**
   * Id of current operation (if exists)
   */
  id?: string;
  /**
   * Number of features created by current operation
   */
  nbCreated: number;
  /**
   * Number of features deleted by current operation
   */
  nbDeleted: number;
  /**
   * Number of features updated by current operation
   */
  nbUpdated: number;
}
